import { EQUALS } from 'utils/comparatorTypes';
import { MULTI_SELECT_FIELDS } from '../../criteriaPropertyField/constants';

export const isIsOneOfComparator = ({
  value: comparator,
  values,
  field,
  isMultiSelectInputAllowed,
  isMultiSelectWithListMembershipAllowed,
}: {
  value: string;
  values?: string[];
  field: string;
  isMultiSelectInputAllowed: boolean;
  isMultiSelectWithListMembershipAllowed: boolean;
}) => {
  const isMultiSelectFields = MULTI_SELECT_FIELDS.includes(field);
  return (
    comparator === EQUALS &&
    Array.isArray(values) &&
    !isMultiSelectFields &&
    (isMultiSelectInputAllowed || isMultiSelectWithListMembershipAllowed)
  );
};
